import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg, { getWebPageSchema } from '@/components/feature/SchemaOrg';
import { categories, movies } from '@/mocks/movies';
import { Helmet } from '@/pages/home/components/SEO';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'dongzuo');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const activeCategory = categories.find((c) => c.slug === activeSlug);
  const filteredMovies = movies.filter((m) => m.categorySlug === activeSlug);
  const category = activeCategory || categories[0];

  return (
    <>
      <Helmet
        title={`${category.name} - 被窝网电影免费高清在线观看`}
        description={`被窝网电影${category.name}频道，为您提供${category.name}免费高清在线观看，海量${category.name}资源聚合，播放流畅不缓冲，尽在被窝网电影大全。`}
        keywords={`被窝网电影${category.name},${category.name}在线观看,${category.name}免费,高清${category.name},被窝网电影`}
        canonicalUrl={`/category/${category.slug}`}
      />
      <SchemaOrg schema={getWebPageSchema(
        `${category.name} - 被窝网电影免费高清在线观看`,
        `被窝网电影${category.name}频道，为您提供${category.name}免费高清在线观看，海量${category.name}资源聚合。`,
        `/category/${category.slug}`,
        [
          { name: '首页', url: '/' },
          { name: '电影分类', url: '/category/dongzuo' },
          { name: category.name, url: `/category/${category.slug}` },
        ]
      )} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '电影分类' },
              { label: category.name },
            ]}
          />

          <section className="w-full bg-background-100 py-8 md:py-10">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500">
                  共 {filteredMovies.length} 部{category.name}资源，高清流畅在线观看
                </p>
              </div>
            </div>
          </section>

          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-wrap gap-2 mb-8">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      activeSlug === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {filteredMovies.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
                  {filteredMovies.map((movie) => (
                    <MovieCard key={movie.id} movie={movie} />
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-20 text-center">
                  <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                    <i className="ri-movie-line text-3xl" />
                  </div>
                  <p className="text-foreground-500 text-sm">
                    暂无{category.name}资源，请浏览其他分类
                  </p>
                  <Link
                    to="/"
                    className="mt-4 px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    返回首页
                  </Link>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}